import React, { Component } from 'react'
import AddTitleBar from '../titleBar/add_titleBar'
import { Button, Container, Header, Icon, Segment, Table } from 'semantic-ui-react'
import AgGridTable from '../agGrid/agGridTable'

export default class Settings extends Component {
    render() {
        let columnDefs = [
            { headerName: 'No. of Vehicles', field: 'numsOfVehicle', tooltipField: 'numsOfVehicle', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Type', field: 'vehicleType', tooltipField: 'vehicleType', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Load Capacity', field: 'vehicleLoadCapacity', tooltipField: 'vehicleLoadCapacity', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Length', field: 'vehicleLength', tooltipField: 'vehicleLength', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Width', field: 'vehicleWidth', tooltipField: 'vehicleWidth', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Height', field: 'vehicleHeight', tooltipField: 'vehicleHeight', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
        ]
        return (
            <div>
                <AddTitleBar Title="Settings" LinkName="/transporter-onboarding" />
                <Container fluid className="mt-3">
                    <Table size="small" className="p-0 m-0">
                        <Table.Row>
                            <Table.HeaderCell>
                                <Header className="mt-1 labelName" size="small" color="blue">Vehicle Availability</Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="right">
                                <Button size="mini" basic icon color="blue"><Icon name="plus" /> New</Button>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table>
                    <AgGridTable
                        columnDefs={columnDefs}
                        hiddenOEBtn={false}
                        hidePopNew={true}
                        mode="create"
                        linkToNew="/new-customer-order"
                        titleBarTitle={"Customer Order"}
                        // actionButton={ActionButton}
                        updated={this.updated}
                        // rowData={rowData}
                        // searchValue={this.state.search_value}
                        handleSearch={this.handleSearch}
                        baseURL={this.props.locationHistory}
                    />
                    <Segment>
                        <Header className="labelName" size="small" color="blue">Route Sequencing Constraints</Header>
                    </Segment>
                </Container>
            </div>
        )
    }
}
